import { render, staticRenderFns } from "./UserDefinedFields.vue?vue&type=template&id=2551de7c"
import script from "./UserDefinedFields.vue?vue&type=script&lang=js"
export * from "./UserDefinedFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports